import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { styled } from '@mui/material/styles';
import Popper from '@mui/material/Popper';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { PROMETHEAN_HEAVY_SHADOW, PROMETHEAN_HEAVY_SHADOW_UP, PROMETHEAN_NO_SHADOW } from '../styles/elevation/elevation';
import { PROMETHEAN_NEUTRAL_WHITE } from '../styles/colors/colors';
var StyledPopper = styled(Popper)(_objectSpread(_objectSpread({}, PROMETHEAN_HEAVY_SHADOW), {}, {
  borderRadius: 8,
  '.MuiPaper-elevation': _objectSpread({}, PROMETHEAN_NO_SHADOW),
  backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
  zIndex: 1300,
  '&.EmbersPopper-menuOnTop': _objectSpread({}, PROMETHEAN_HEAVY_SHADOW_UP)
}));
export var EmbersPopper = function EmbersPopper(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    popperPlacedOnTop = _useState2[0],
    setPopperPlacedOnTop = _useState2[1];
  var popperRef = useRef(null);

  // this is to get a class name on the popper which we can use to style it
  //  because the menu shadow is wrong when the popper moves on top
  var shadowFlipModifier = {
    name: 'shadowFlipModifier',
    enabled: true,
    phase: 'main',
    fn: function fn(args) {
      if (popperPlacedOnTop) {
        if (args.state.placement.includes('bottom')) {
          setPopperPlacedOnTop(false);
        }
      } else {
        if (args.state.placement.includes('top')) {
          setPopperPlacedOnTop(true);
        }
      }
    }
  };
  var offsetTopModifier = {
    name: 'offsetTopModifier',
    enabled: !!props.verticalOffset,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: function fn(_ref) {
      var state = _ref.state;
      if (props.verticalOffset && state.placement.includes('bottom')) {
        if (state.modifiersData.popperOffsets) {
          state.modifiersData.popperOffsets.y += props.verticalOffset;
        }
      }
    }
  };
  var sameWidthModifier = {
    name: 'sameWidth',
    enabled: !!props.fullWidth,
    phase: 'beforeWrite',
    requires: ['computeStyles'],
    fn: function fn(_ref2) {
      var state = _ref2.state;
      state.styles.popper.width = "".concat(state.rects.reference.width, "px");
      state.styles.popper.minWidth = "".concat(state.rects.reference.width, "px");
    },
    effect: function effect(_ref3) {
      var state = _ref3.state;
      // @ts-ignore
      state.elements.popper.style.width = "".concat(state.elements.reference.offsetWidth, "px");
    }
  };
  var handleDocKeyDown = function handleDocKeyDown(e) {
    if (props.onKeyDown) {
      props.onKeyDown(e);
    }
    switch (e.key) {
      case 'Tab':
        if (!props.disableCloseOnTab) {
          props.onEscape && props.onEscape();
        }
        break;
      case 'Escape':
        props.onEscape && props.onEscape();
        break;
      default:
        break;
    }
  };
  var handleWindowResize = function handleWindowResize() {
    // when the user resizes the window we close the popper.
    //  This also handles the case where the user zooms the
    //  window contents by keyboard control
    if (props.onEscape && !props.disableCloseOnWindowResize) {
      props.onEscape();
    }
  };
  useLayoutEffect(function () {
    window.addEventListener('resize', handleWindowResize);
    return function () {
      return window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  // isNotInPopper() returns "is elem 1) not inside the popper; and
  //  2) is not inside  the button that anchors the popper"
  var isNotInPopper = function isNotInPopper(elem) {
    var anElem = elem;
    if (anElem) {
      while (anElem !== popperRef.current && anElem !== props.anchorEl) {
        var _anElem;
        var nextParent = (_anElem = anElem) === null || _anElem === void 0 ? void 0 : _anElem.parentElement;
        if (!nextParent) {
          break;
        }
        anElem = nextParent;
      }
    }
    return anElem !== popperRef.current && anElem !== props.anchorEl;
  };
  var handleDocClick = function handleDocClick(e) {
    if (props.onEscape && isNotInPopper(e.target)) {
      e.stopPropagation();
      if (!props.shouldPreventClose || !props.shouldPreventClose(e)) {
        props.onEscape();
      }
    }
  };
  var handleDocTouchStart = function handleDocTouchStart(e) {
    if (props.onEscape && isNotInPopper(e.target)) {
      e.stopPropagation();
      if (!props.shouldPreventClose || !props.shouldPreventClose(e)) {
        props.onEscape();
      }
    }
  };
  useEffect(function () {
    if (props.onEscape) {
      if (props.open) {
        var _props$onOpen;
        document.addEventListener('keydown', handleDocKeyDown);
        document.addEventListener('mousedown', handleDocClick);
        document.addEventListener('touchstart', handleDocTouchStart);
        (_props$onOpen = props.onOpen) === null || _props$onOpen === void 0 || _props$onOpen.call(props);
      }
      return function () {
        document.removeEventListener('keydown', handleDocKeyDown);
        document.removeEventListener('mousedown', handleDocClick);
        document.removeEventListener('touchstart', handleDocTouchStart);
      };
    }
  }, [props.open, props.onEscape]);
  return /*#__PURE__*/React.createElement(StyledPopper, {
    ref: popperRef,
    id: props.id,
    anchorEl: props.anchorEl,
    open: props.open,
    placement: props.placement || 'bottom-start',
    role: "presentation",
    modifiers: [shadowFlipModifier, sameWidthModifier, offsetTopModifier].concat(_toConsumableArray(props.modifiers || [])),
    className: classnames(props.className, {
      'EmbersPopper-root': true,
      'EmbersPopper-menuOnTop': popperPlacedOnTop
    })
  }, props.children);
};